// import merchantContract from './AFinancial_Merchant_Contract.pdf';
import SGPDF from './SG-Merchant-Contract.pdf';
import IDPDF from './ID-Merchant-Contract.pdf';
import MYPDF from './MY-Merchant-Contract.pdf';
import HKPDF from './HK-Merchant-Contract.pdf';
import { countryCode } from '@/lib/locale';

const mcMap: any = {
  SGPDF,
  IDPDF,
  MYPDF,
  HKPDF,
};

const merchantContract = mcMap[`${countryCode}PDF`];

export default merchantContract;
